import { ActionsKanban } from "@/components/actions-kanban";
import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

// Permissive schema for route validation - accepts any strings
const routeSearchSchema = z.object({
  formType: z.string().optional(),
  dateCreated: z.string().optional(),
  department: z.string().optional(),
});

export const Route = createFileRoute(
  "/(dashboard)/_authenticated/$companyId/team/$teamId/actions",
)({
  component: RouteComponent,
  validateSearch: zodValidator(routeSearchSchema),
});

function RouteComponent() {
  const { companyId, teamId } = Route.useParams();
  return <ActionsKanban companyId={companyId} teamId={teamId} />;
}
